import styled from 'styled-components';

// 운동 메모와 같은 곳에 사용되는 기본 텍스트
export const Text = styled.div`
  color: var(--Gray-Scale-600, #756f7e);

  /* NEW/body_03_medium */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`;
